export const MOBILE_WARNING_NAME = 'MOBILE_DETAILS_WARNING_READ_';
